module.exports = __webpack_public_path__ + "media/dLQ.501974fc.wav";